import { render } from "./View.vue?vue&type=template&id=2fd98f15"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app.rizome-bxl.be/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__